import {
  Typography,
  Box,
  Grid,
  Paper,
  Avatar,
  Container,
} from "@mui/material";
import CtBtn from "../CustomTool/CtBtn";

import { ArrowForward } from "@mui/icons-material";
import { TestimonialsPage } from "./AllTestimonialsPage";
import { useState } from "react";

const testimonials = [
  {
    name: "Rahul Sharma",
    role: "Store Owner",
    text: "Simplified my billing and GST return workflow — saved hours each week.",
  },
  {
    name: "Neha Patel",
    role: "Accountant",
    text: "Powerful reports and easy reconciliation. Exactly what my clients needed.",
  },
  {
    name: "Anita Verma",
    role: "Retail Shop Owner",
    text: "Inventory tracking became effortless — no more stock surprises and faster billing.",
  },
  {
    name: "Vikram Joshi",
    role: "Accountant",
    text: "Client accounting is cleaner now, GST reports are accurate and easy to export.",
  },
];

function Testimonials() {
  const [testimonialsOpen, setTestimonialsOpen] = useState(false);

  const handleOpenTestimonials = () => {
    setTestimonialsOpen(true);
  };

  const handleCloseTestimonials = () => {
    setTestimonialsOpen(false);
  };
  return (
    <div style={{ padding: "30px 0px" }}>
      <Box textAlign="center" sx={{ mb: 2 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            mb: 2,
            color: "primary.main",
          }}
        >
          Trusted by Businesses
        </Typography>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ mx: "auto", mt: 0 }}
        >
          See what our customers say about their experience with Rite Account
        </Typography>
      </Box>

      <Grid container spacing={1} justifyContent={"center"} pb={3}>
        {testimonials.map((t, idx) => (
          <Grid item xs={6} md={6} key={idx}>
            <Paper
              elevation={0}
              sx={{
                padding: 2,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  boxShadow: 2,
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "flex-start" }}>
                <Avatar
                  sx={{
                    bgcolor: "primary.main",
                    width: 48,
                    height: 48,
                    mr: 2,
                  }}
                >
                  {t.name.charAt(0)}
                </Avatar>
                <Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <Typography sx={{ fontWeight: 700, mr: 1 }}>
                      {t.name}
                    </Typography>
                    <Box sx={{ color: "gold" }}>★★★★★</Box>
                  </Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                    sx={{ mb: 1.5 }}
                  >
                    {t.role}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ fontStyle: "italic" }}
                    maxWidth={500}
                  >
                    "{t.text}"
                  </Typography>
                </Box>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Grid container justifyContent={"center"}>
        <Grid item>
          <CtBtn
            variant="outlined"
            sx={{ borderRadius: 2 }}
            onClick={handleOpenTestimonials}
            label="Read more testimonials"
          />
        </Grid>
      </Grid>
      <TestimonialsPage
        open={testimonialsOpen}
        onClose={handleCloseTestimonials}
      />
    </div>
  );
}

export default Testimonials;
